const initialState = {
  totalRegistros: 0,
  isLoading: false,
  obraDiario: [],
  id: '',
  idObra: 0,
  idEmpresa: 0,
  data: '',
  condicaoClimatica: '',
  observacoes: '',
  responsavelTecnico: '',
  obra: [],
  empresa: [],
  obrasDiariosAnexos: [],
  obrasDiariosEquipes: []
}

export function obraDiario(state = initialState, action) {
  switch (action.type) {
    case 'CREATE_OBRA_DIARIO_REQUEST':
      return {
        ...state,
        isLoading: true
      }
    case 'CREATE_OBRA_DIARIO_SUCCESS':
      return {
        ...state,
        id: action.obraDiario.id,
        isLoading: false,
        idObra: action.obraDiario.idObra,
        idEmpresa: action.obraDiario.idEmpresa,
        data: action.obraDiario.data,
        condicaoClimatica: action.obraDiario.condicaoClimatica,
        observacoes: action.obraDiario.observacoes,
        responsavelTecnico: action.obraDiario.responsavelTecnico,
        obra: action.obraDiario.obra,
        empresa: action.obraDiario.empresa,
        obrasDiariosAnexos: action.obraDiario.obrasDiariosAnexos,
        obrasDiariosEquipes: action.obraDiario.obrasDiariosEquipes
      }
    case 'CREATE_OBRA_DIARIO_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case 'EDIT_OBRA_DIARIO_REQUEST':
      return {
        ...state,
        isLoading: true
      }
    case 'EDIT_OBRA_DIARIO_SUCCESS':
      return {
        ...state,
        id: action.obraDiario.id,
        isLoading: false,
        idObra: action.obraDiario.idObra,
        idEmpresa: action.obraDiario.idEmpresa,
        data: action.obraDiario.data,
        condicaoClimatica: action.obraDiario.condicaoClimatica,
        responsavelTecnico: action.obraDiario.responsavelTecnico,
        obra: action.obraDiario.obra,
        empresa: action.obraDiario.empresa,
        obrasDiariosAnexos: action.obraDiario.obrasDiariosAnexos,
        obrasDiariosEquipes: action.obraDiario.obrasDiariosEquipes
      }
    case 'EDIT_OBRA_DIARIO_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case 'FETCHED_ALL_OBRA_DIARIO':
      return {
        ...state,
        obraDiario: action.obraDiario,
        totalRegistros: action.totalRegistros
      }
    case 'OBRA_DIARIO_DETAIL':
      return {
        ...state,
        id: action.id,
        isLoading: false,
        idObra: action.idObra,
        idEmpresa: action.idEmpresa,
        data: action.data,
        condicaoClimatica: action.condicaoClimatica,
        responsavelTecnico: action.responsavelTecnico,
        obra: action.obra,
        empresa: action.empresa,
        obrasDiariosAnexos: action.obrasDiariosAnexos,
        obrasDiariosEquipes: action.obrasDiariosEquipes
      }
    case 'OBRA_DIARIO_CLEAR':
      return initialState
    case 'OBRA_DIARIO_ESTABELECIMENTO_ADD_SUCCESS':
      return {
        ...state,
        obraDiario: [...state.obraDiario, action.data.obraDiario]
      }
    case 'OBRA_DIARIO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'OBRA_DIARIO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'OBRA_DIARIO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
